import Vue from 'vue'
import Vuex from 'vuex'
import {Map, Set} from 'immutable'
import Socket = SocketIOClient.Socket;

Vue.use(Vuex)

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IOInfo {
  socket: Socket;
  roomId: string;
  peerId: string;
}

export default new Vuex.Store({
  state: {
    windowOrientation: 'landscape',
    ioInfo: {} as IOInfo,
    nicks: {} as Record<string, string>,
    badges: Map<string, Set<string>>()
  },
  mutations: {
    changeWindowOrientation(state, orientation: string) {
      state.windowOrientation = orientation
    },
    setRoom: (state, roomId: string) => {
      state.ioInfo.roomId = roomId
    },
    setPeerId: (state, peerId: string) => {
      state.ioInfo.peerId = peerId
    },
    setSocket: (state, socket: Socket) => {
      state.ioInfo.socket = socket
    },
    setNicks: (state, nicks: Record<string, string>) => {
      state.nicks = nicks
    },
    setBadges: (state, {ids, badge}: { ids: string[]; badge: string }) => {
      let current = state.badges
      current = current.map(((value, key) => value.remove(badge)))
      ids.forEach(id => current = current.set(id, (current.get(id) ?? Set()).add(badge)))
      state.badges = current
    },
    setBadge: (state, {id, badge}: { id: string; badge: string }) => {
      state.badges = state.badges.set(id,
        state.badges.get(id)?.add(badge) ?? Set([badge]))
    },
    deleteBadge: (state, {id, badge}: { id: string; badge: string }) => {
      if (state.badges.has(id))
        state.badges = state.badges.set(id,
          state.badges.get(id)?.delete(badge) ?? Set())
      else
        state.badges = state.badges.remove(id)
    },
  },
  actions: {},
  getters: {
    myNick: state => state.nicks[state.ioInfo.peerId]
  },
  modules: {}
})
